module.exports = __webpack_public_path__ + "media/images/games/clash-royale/add-friend-caa3ff701797deb972707e67f305e9db.png";